/* eslint-disable no-fallthrough */
/* eslint-disable no-unused-vars */
import { Modal } from "antd";
import React, { useState } from "react";
import "./ConnectDialog.css";
import Instagram from '../../assets/svg/instagram.svg'
import Twitter from '../../assets/svg/twitter.svg'
import Pinterest from '../../assets/svg/pinterest_social.svg'
import TikTok from '../../assets/svg/tik-tok.svg'
import facebook from '../../assets/svg/facebook.svg'
import Google from '../../assets/svg/google.svg'
import YouTube from '../../assets/svg/youtube.svg'
import Yahoo from '../../assets/svg/yahoo.svg'

import GIF from '../../assets/gifs/check-animation.gif'
import InstagramLogin from 'react-instagram-login';
import TwitterLogin from "react-twitter-login";
import GoogleLogin from 'react-google-login';
import FacebookLogin from 'react-facebook-login';
import { instaClientId, instaScope, instaRedirectUrl } from '../../utils/Constants';

import { withFirebase } from '../../auth/firebase';


const SocialDialog = ({ modalVisible, toggleDialog, setSocialLogged, toggleCreate, firebase }) => {
  console.log(`firebase ===> `, firebase)

  const [loading, setLoading] = useState(false);



  const connectToSocial = (social) => {

    // setLoading(true)
    // setLoading(false)
    // toggleDialog();
    // toggleCreate();
    // setSocialLogged(true);

    firebase.auth.onAuthStateChanged(function (user) {
      if (user) {
        console.log(`user =====> `, user);
        setSocialLogged(true);
        toggleDialog();
        toggleCreate();
        // User is signed in.
      } else {
        // No user is signed in.
      }
    });

    switch (social) {

      case 'yahoo': {
        firebase.signInWithYahoo();
        return;
      }
      case 'twitter': {
        const user = firebase.getCurrentLoginUser();
        console.log(`user ===> `, user);
        setSocialLogged(true);
        toggleDialog();
        toggleCreate();
        return;
      }

      case 'google': {
        firebase.signInWithGoogle();
        return;
      }

      case 'facebook': {
        firebase.signInWithFacebook();
        return;
      }

      default:
        console.log('instagram')
    }
  }

  const successResponseInstagram = (response) => {
    console.log('response >>>', response);
  }

  const failResponseInstagram = (response) => {
    console.log(`response ====> `, response)
  }

  const responseTwitter = (response) => {
    console.log(`response ====> `, response)
  }

  const responseGoogle = (response) => {
    console.log(`response ===> `, response)
    alert('User email: ' + response.profileObj.email);
  }

  const responseFacebook = (response) => {
    console.log(`response ===> `, response);
    alert('User email: ' + response.email);
  }

  const getFacebookButtonText = () => {
    return (
      <div style={{ display: 'flex' }}>
        <img
          style={{ textAlign: 'left' }}
          src={YouTube}
          alt="facebook"
        />
        <h2 className='connect-dialog-button-heading'>Facebook</h2>
      </div>)
  }

  return (
    <div>
      <Modal
        width={window.screen.width > 500 ? "30vw" : "90vw"}
        mask={true}
        style={{ top: 15 }}
        maskStyle={{ background: "rgba(0, 0, 0, .8)" }}
        title="Connect"
        visible={modalVisible}
        onOk={toggleDialog}
        onCancel={toggleDialog}
        footer={[]}
      >
        <div className="connect-dialog">
          {loading ?
            <div className="social-connect-dialog">
              <img
                className="social-done-gif"
                src={GIF}
                alt="gif social animation"
              />
              <h2>Connected to your account</h2>
              <p>Please wait for a moment</p>
            </div> :
            <div className="connect-container">
              <h1>Connect your social account</h1>
              <h3>
                Login with one of your social media account
            </h3>
              <div className="connect-item-container">



                {
                  //   <InstagramLogin
                  //   clientId={instaClientId}
                  //   scope={instaScope}
                  //   onSuccess={successResponseInstagram}
                  //   onFailure={failResponseInstagram}
                  //   cssClass={"connect-item"}
                  //   redirectUri={instaRedirectUrl}
                  // >  <img
                  //     src={Instagram}
                  //     alt="instagram"
                  //   /> <span style={{ marginLeft: '5px' }}>Login with Instagram</span>
                  // </InstagramLogin>
                }
                <div className="connect-item" onClick={() => { connectToSocial('yahoo') }}>
                  <img
                    src={Yahoo}
                    alt="Yahoo"
                  />
                  <h2>Yahoo</h2>
                </div>

                <div className="connect-item" onClick={() => { connectToSocial('twitter') }}>
                  <img
                    src={Twitter}
                    alt="twitter"
                  />
                  <h2>Twitter</h2>
                </div>

                {
                  //   <TwitterLogin
                  //   authCallback={responseTwitter}
                  //   // className={classes.login__btn}
                  //   // consumerKey={CONSUMER_KEY}
                  //   consumerSecret={'L8qq9PZyRg6ieKGEKhZolGC0vJWLw8iEJ88DRdyOg'}
                  // // children={<button>Login with Twitter</button>}
                  // ></TwitterLogin>
                }

                {
                  //   <GoogleLogin
                  //   className="connect-item"
                  //   clientId="585272359503-68f8k2a8ilsf54fe8lfd7dku8cm09i3s.apps.googleusercontent.com"
                  //   buttonText="Login with Google"
                  //   as={'text'}
                  //   onSuccess={responseGoogle}
                  //   onFailure={responseGoogle}
                  //   cookiePolicy={'single_host_origin'}
                  // />
                }
                <div className="connect-item" onClick={() => { connectToSocial('google') }}>
                  <img
                    src={Google}
                    alt="google"
                  />
                  <h2>Google</h2>
                </div>

                {
                  //   <FacebookLogin
                  //   cssClass="connect-item"
                  //   appId="896919810857559"
                  //   // autoLoad={true}
                  //   fields="name,email,picture"
                  //   // cssClass={classes.login__btn}
                  //   callback={responseFacebook}
                  //   textButton={getFacebookButtonText()}
                  // />
                }

                <div className="connect-item" onClick={() => { connectToSocial('facebook') }}>
                  <img
                    src={facebook}
                    alt="facebook"
                  />
                  <h2>Facebook</h2>
                </div>

                {
                  // <div className="connect-item" onClick={()=>{}}>
                  //   <img
                  //     src={YouTube}
                  //     alt="youtube"
                  //   />
                  //   <h2>YouTube</h2>
                  // </div>
                }
              </div>
              <h3>We do not share your account details to anyone. We care about your privacy</h3>
            </div>
          }
        </div>
      </Modal>
    </div>
  );
};

export default withFirebase(SocialDialog);
